import React, { useState, useEffect } from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { Requirement, Area } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { useLanguage } from "../../../../contexts";

const requirementController = new Requirement();
const areaController = new Area();

export function RequirementForm({ requirement, close, onReload }) {
  const { accessToken } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const [areaOptions, setAreaOptions] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const areas = await areaController.getAreas(accessToken);
        setAreaOptions(areas.map((a) => ({ key: a._id, value: a._id, text: a.name })));
      } catch {}
    })();
  }, []);

  const formik = useFormik({
    initialValues: {
      code: requirement?.code || "",
      name: requirement?.name || "",
      area: (requirement?.area?._id || requirement?.area) ?? "",
    },
    validationSchema: Yup.object({
      code: Yup.string(),
      name: Yup.string().required("El nombre es requerido"),
    }),
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const payload = { ...values };
        if (!payload.area) delete payload.area;
        if (requirement) {
          await requirementController.updateRequirement(accessToken, requirement._id, payload);
          toast.success(t("updated"));
        } else {
          await requirementController.createRequirement(accessToken, payload);
          toast.success(t("created"));
        }
        onReload();
        close();
      } catch (err) {
        toast.error(err?.msg || t("error"));
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit} style={{ padding: "0.5rem" }}>
      <ToastContainer position="top-center" autoClose={800} hideProgressBar />
      <Form.Input
        label={t("code")}
        name="code"
        value={formik.values.code}
        onChange={formik.handleChange}
        error={formik.errors.code}
        placeholder="Ej: REQ-01"
      />
      <Form.Input
        label={<label>{t("name")} <span style={{ color: "#C0392B" }}>*</span></label>}
        name="name"
        value={formik.values.name}
        onChange={formik.handleChange}
        error={formik.errors.name}
        placeholder="Ej: Hi"
      />
      <Form.Select
        label={t("area")}
        name="area"
        value={formik.values.area}
        options={[{ key: "", value: "", text: `-- ${t("no_area") || "Sin área"} --` }, ...areaOptions]}
        onChange={(_, { value }) => formik.setFieldValue("area", value)}
        placeholder={t("area")}
        clearable
      />
      <div style={{ display: "flex", justifyContent: "center", gap: "14px", marginTop: "2rem" }}>
        <button type="submit" disabled={formik.isSubmitting} style={{ background: "#4A7FA5", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer", opacity: formik.isSubmitting ? 0.55 : 1 }}>
          {formik.isSubmitting ? "…" : (requirement ? t("update") : t("save"))}
        </button>
        <button type="button" onClick={close} style={{ background: "#9BAFC4", color: "#fff", border: "none", borderRadius: "20px", padding: "10px 30px", fontSize: "14px", fontWeight: 600, fontFamily: "'Archivo', sans-serif", cursor: "pointer" }}>
          {t("cancel")}
        </button>
      </div>
    </Form>
  );
}
